<template>
  <div>
    <div class="search-container">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </div>
    <TableRefresh 
      :state="loading"
      @click.native="getOrgs"
    />
    <div v-if="loading" class="pvcam-loading" :style="{ backgroundImage: `url(/favicon.png)` }"></div>
    <v-data-table
      :headers="fiteredTableHeaders"
      :items="$can('listOrgs') ? orgs : []"
      :loading="loading"
      :search="search"
      class="elevation-1 admin-table"
    >

      <template v-slot:item.users="{ item }">
        <v-icon :disabled="!$can('listUsers')" @click="toOrg(2, item)">
          mdi-account-group
        </v-icon>
      </template>

      <template v-slot:item.vehicles="{ item }">
        <v-icon @click="toOrg(3, item)">
          mdi-car-multiple
        </v-icon>
      </template>

      <template v-slot:item.edit="{ item }">
        <v-icon :disabled="!$can('viewOrg')" @click="toOrg(1, item)">
          mdi-file
        </v-icon>
      </template>

      <template v-slot:item.app="{ item }">
        <v-icon :disabled="!$can('viewOrg')" @click="launchCustomerSite(item)">
          mdi-dots-horizontal
        </v-icon>
      </template>

    </v-data-table>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="400px">
        <v-card>
          <v-card-title>
            <span class="headline">Add Organisation</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-form ref="org" v-model="valid" style="width: 100%;">
                  <v-flex md12>
                    <v-text-field v-model="name" label="Organisation Name*" :rules="nameRules" autofocus></v-text-field>
                  </v-flex>
                  <v-flex md12>
                    <v-text-field v-model="primaryPhone" label="Primary Phone*" :rules="nameRules"></v-text-field>
                  </v-flex>
                  <v-flex md12>
                    <v-text-field v-model="primaryEmail" label="Primary Email*" :rules="emailRules"></v-text-field>
                  </v-flex>
                  <v-flex md12>
                    <v-text-field v-model="secondaryPhone" label="Secondary Phone"></v-text-field>
                  </v-flex>
                  <v-flex md12>
                    <v-text-field v-model="secondaryEmail" label="Secondary Email"></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
										<pvcam-wc-country-selector
                      :target="'Profile'"
											:disabled="false"
											:current-selection="''"
										/>
									</v-flex>
                </v-form>
              </v-layout>
            </v-container>
            <small>*indicates required field</small>
          </v-card-text>
          <v-card-actions class="text-xs-center">
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              text
              @click="
                dialog = false
                clearForm()
              "
              >Close</v-btn
            >
            <v-btn 
              :loading="loading" 
              :disabled="loading || !valid || !hasCountry" 
              color="secondary" 
              @click.prevent="createOrg"
            >
              Add
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>

import { AmplifyEventBus } from "aws-amplify-vue"
import { Logger } from "aws-amplify"
import { mapMutations, mapState } from "vuex"
import { ListAccessibleOrgs, CreateOrg } from "@/services/API.js"
import Auth from "@/services/Auth.js"

import TableRefresh from '@/components/general/TableRefresh.vue';

const logger = new Logger("OrgCardList")

export default {
  name: 'AddNewOrg',
  components: {
    TableRefresh
  },
  data: () => ({
    options: [{ title: "Profile" }],
    loading: true,
    orgs: [],
    fabs: {
      id: [],
      hover: [],
    },
    dialog: false,
    valid: false,
    name: "",
    primaryPhone: "",
    primaryEmail: "",
    secondaryPhone: "",
    secondaryEmail: "",
    countryCode: "",
    nameRules: [(value) => !!value || "Required."],
    emailRules: [(v) => !!v || "E-mail is required", (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail must be valid"],
    headers: [
      {
        text: 'Name',
        align: 'left',
        value: 'name',
      },
      {
        text: 'Users',
        align: 'left',
        value: 'users'
      },
      {
        text: 'Vehicles',
        align: 'left',
        value: 'vehicles'
      },
      {
        text: 'Edit',
        align: 'left',
        value: 'edit'
      },
      {
        text: 'View in App',
        align: 'left',
        value: 'app'
      }
    ],
    search: ''
  }),
  computed: {
    ...mapState (['goToken', 'driverHoursProviderName', 'telematicsProviderName', 'driverHoursProviderUrl', 'telematicsProviderUrl', 'DashBoardUserId']),
    hasCountry() {
      return this.countryCode.length > 0 ? true : false;
    },
    fiteredTableHeaders () {
				return this.headers
		},
  },
  mounted() {
    window.EventBus.$on("updateOrgProfile", this.handleSelectedCountry);
    this.getOrgs()
    AmplifyEventBus.$on("createNode", (info) => {
      if (info === "createOrg") {
        this.dialog = true
      }
    })
  },
  methods: {
    handleSelectedCountry(val) {
      this.countryCode = val;
    },
     ...mapMutations("presence", [
      "setOrgToWatch", 
    ]),
    async getOrgs() {
      this.loading = true;
      this.orgs = [];
      
      const orgs = await ListAccessibleOrgs()

      this.orgs = orgs ? orgs.sort((a, b) => a.name.localeCompare(b.name)) : []
      this.loading = false
    },
    async postOrg() {
      const { name, primaryPhone, primaryEmail, secondaryPhone, secondaryEmail, countryCode } = this
      const body = {
        name,
        primaryPhone,
        primaryEmail,
        secondaryPhone,
        secondaryEmail,
        countryCode
      }
      const res = await CreateOrg(body)
      return res
    },
    async createOrg() {
      if (this.$refs.org.validate()) {
        this.loading = !this.loading
        const res = await this.postOrg()
                
        this.dialog = false;
        this.getOrgs();
        if (!res) {
          //do somthing
          this.loading = false
        }
      }
    },
    clearForm() {
      this.$refs.org.reset()
    },
    toOrg(id, org) {
      this.setOrgToWatch(org.id)
      switch (id) {
        case 1:
          this.$router.push({ path: `/organisation/${org.id}` })
          break
        case 2:
          this.$router.push({ path: `/organisation/${org.id}/users` })
          break
        case 3:
          this.$router.push({
            path: `/organisation/${org.id}/vehicles`,
          })
          break
        case 4:
          this.$router.push({
            path: `/organisation/${org.id}/devices`,
          })
          break
        default:
          this.$router.push({ path: `/organisation/${org.id}` })
          break
      }
    },
    toOrgUsers(name) {
      // const param = name.replace(/ /g, "-");
      logger.info(`/organisation/${name}`)
    },
    toOrgVehicles(name) {
      // const param = name.replace(/ /g, "-");
      logger.info(`/organisation/${name}`)
    },
    toOrgDevices(name) {
      // const param = name.replace(/ /g, "-");
      logger.info(`/organisation/${name}`)
    },
    async launchCustomerSite(org) {
      let dataToSend = {
        orgID: org.id
      }

      // if we have a go token, we need to pass over all the data the customer site might expect from the GoPortal
      if(this.goToken) {
        const session = await Auth.currentSession()
        dataToSend.camtoken = session.refreshToken
        dataToSend.gotoken = this.goToken
        dataToSend.driverHoursProviderName = this.driverHoursProviderName
        dataToSend.telematicsProviderName = this.telematicsProviderName
        dataToSend.driverHoursProviderUrl = this.driverHoursProviderUrl
        dataToSend.telematicsProviderUrl = this.telematicsProviderUrl
        dataToSend.DashBoardUserId = this.DashBoardUserId
        dataToSend.gouser = true
      }

      let newTab = window.open(location.protocol + "//" + process.env.VUE_APP_user_domain, '_blank')
      newTab.name = JSON.stringify(dataToSend)
    }
  },
}
</script>

<style lang="scss">
.orgnisation-container {
  position: relative;
  .v-btn--floating {
    position: relative;
  }
  .v-card {
    transition-property: box-shadow, transform;
    transition-duration: 0.3s;
    transform: perspective(1px) translateZ(0);
    .title {
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  &:hover,
  &:focus,
  &:active {
    .v-card {
      box-shadow: 0 10px 10px -10px rgba(0, 0, 0, 0.5);
      transform: scale(1.1);
      .title {
        animation: text-blur 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
      }
    }
  }
}
.v-speed-dial__list {
  position: absolute !important;
  left: 0 !important;
  width: 100% !important;
  display: flex !important;
  justify-content: space-evenly !important;
}
.search-container {
  width: 20em;
  padding-left: 1em;
}
</style>
